import React, { useEffect, useCallback, useState } from 'react';
import { parseISO, format } from 'date-fns';
import pt from 'date-fns/locale/pt-BR';
import { toast } from 'react-toastify';
import fileDownload from 'js-file-download';
import { FormLabel, FormGroup } from '@material-ui/core';
import {
  FaFacebookSquare,
  FaInstagram,
  FaRobot,
  FaPenSquare,
  FaWindowMaximize,
  FaTimes,
  FaWeebly,
  FaRocketchat,
  FaWhatsapp
} from 'react-icons/fa';
import { IoMdMail } from 'react-icons/io';
import api from '~/services/api';
import isNumber from '~/util/isNumber';
import DebounceTextField from './Table/DebounceTextField';
import { Container, Menus, Filtro, DS, Button } from './styles';
// Importando componente
import Card from '~/components/Card';
import Load from '~/components/Load';
import Table from './Table';

export default function Atendimento() {
  const [dados, setDados] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [filtroProduto, setFiltroProduto] = useState('');
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('');
  const [dateInit, setDateInit] = useState(null);
  const [dateFinish, setDateFinish] = useState(null);
  const [dataInicial, setDataInicial] = useState(null);
  const [filtroData, setFiltroData] = useState(['0001-01-01 00:00:00', '9999-12-30 23:59:59'])
  const [dataFinal, setDataFinal] = useState(null);
  const [telefone, setTelefone] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(true);
  const [carregar, setCarregar] = useState(false);

  const getDados = useCallback(async () => {
    setCarregar(true);
    const responseDados = await api.get('/atendimentos', {
      params: {
        page,
        perPage,
        all: search,
        status,
        produto: filtroProduto,
        filtroData,
        telefone,
        email,
      },
    });

    const data = responseDados.data.data.map(i => {
      const date = parseISO(i.proximo_atendimento);
      const hours = date;
      let statusFormat;
      switch (i.status) {
        case '1':
          statusFormat = 'Iniciado';
          break;
        case '2':
          statusFormat = 'Em atendimento';
          break;
        case '3':
          statusFormat = 'Cancelado';
          break;
        case '4':
          statusFormat = 'Finalizado';
          break;
        default:
          statusFormat = 'Enviado';
      }
      return {
        ...i,
        dataFormat: format(hours, 'dd/MM/yyyy HH:mm:ss', {
          locale: pt,
        }),
        atraso: i.atraso,
        ten: i.tentativa,
        statusFormat,
        createdAt: format(parseISO(i.created_at), 'dd/MM/yyyy HH:mm:ss', {
          locale: pt,
        }),
      };
    });
    setDados(data);
    setPage(responseDados.data.page);
    setPerPage(responseDados.data.perPage);
    setTotal(Number(responseDados.data.total));
    setLoading(false);
    setCarregar(false);
  }, [
    filtroData,
    email,
    filtroProduto,
    page,
    perPage,
    search,
    status,
    telefone,
  ]);

  const getProdutos = useCallback(async () => {
    const responseProduto = await api.get('/produto-select');
    const data = responseProduto.data.map(produto => {
      return `Produto:${produto.name}`;
    });

    setProdutos(data);
  }, []);

  useEffect(() => {
    getDados();
    getProdutos();
  }, [getDados, getProdutos]);

  async function handlePagination(number) {
    setPage(number);
  }

  async function handlePerPage(number) {
    setPerPage(number);
  }

  function handleSearch(value) {
    setSearch(value);
    setPage(1);
  }

  async function handleExportCSV() {
    try {
      const response = await api.get('export-atendimento-csv', {
        params: {
          all: search,
          status,
          produto: filtroProduto,
          dataInicial,
          dataFinal,
          telefone,
          email,
        },
      });
      fileDownload(response.data, 'relatorio-atendimento.csv');
      toast.success('Download feito com sucesso');
    } catch (error) {
      toast.error('Erro ao tentar fazer download csv.');
    }
  }

  async function handleFilterSubmit(resultados) {
    let produtoFilter;
    let statusFilter;
    let numberFilter;
    let emailFilter;
    resultados.forEach(resultado => {
      if (resultado.filtro === undefined) {
        if (isNumber(resultado.coluna)) {
          numberFilter = resultado.coluna;
        } else {
          emailFilter = resultado.coluna;
        }
      }

      if (resultado.coluna === 'Status') {
        switch (resultado.filtro) {
          case 'Iniciado':
            statusFilter = '1';
            break;
          case 'Em atendimento':
            statusFilter = '2';
            break;
          case 'Cancelado':
            statusFilter = '3';
            break;
          case 'Finalizado':
            statusFilter = '4';
            break;
          default:
            statusFilter = '5';
        }
      }

      if (resultado.coluna === 'Produto') {
        produtoFilter = resultado.filtro;
      }
    });

    if (statusFilter) {
      setStatus(statusFilter);
    } else {
      setStatus('');
    }

    if (produtoFilter) {
      setFiltroProduto(produtoFilter);
    } else {
      setFiltroProduto('');
    }

    if (numberFilter) {
      setTelefone(numberFilter);
    } else {
      setTelefone('');
    }

    if (emailFilter) {
      setEmail(emailFilter);
    } else {
      setEmail('');
    }

    setPage(1);
  }

  function handleAtendimento(number) {
    const win = window.open(`/atendimento-create/${number}`, '_blank');
    win.focus();
  }

  function handleFiltrar() {
    if (dateInit && dateFinish) {
      const dtI = format(dateInit, 'yyyy-MM-dd');
      const dtF = format(dateFinish, 'yyyy-MM-dd');

      setFiltroData([dtI, dtF])
    } else {
      toast.error('Preencha os campos data inicial e data final');
    }
  }

  function handleReset() {
    setSearch('');
    setStatus('');
    setFiltroProduto('');
    setFiltroData(['0001-01-01 00:00:00', '9999-12-30 : 23:59:59'])
    setDateInit(null);
    setDateFinish(null);
    setTelefone('');
    setEmail('');
  }

  const columns = [
    {
      name: 'id',
      label: 'Id',
      options: {
        filter: false,
        sort: true,
        display: false,
      },
    },
    {
      name: 'lead.name',
      label: 'Nome',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'lead.canal',
      label: 'Canal',
      options: {
        filter: false,
        sort: false,
        customBodyRender(value) {
          switch (value) {
            case 'fb':
              return (
                <FaFacebookSquare
                  color="#FFF"
                  size={20}
                  title="Origem: Facebook"
                />
              );
            case 'wp':
              return (
                <FaWhatsapp
                  color="#FFF"
                  size={20}
                  title="Origem: Whatsapp"
                />
              );
            case 'ig':
              return (
                <FaInstagram color="#FFF" size={20} title="Origem: Instagram" />
              );
            case 'bot':
              return <FaRobot color="#FFF" size={20} title="Origem: ChatBot" />;
            case 'cms':
              return <FaPenSquare color="#FFF" size={20} title="Origem: CMS" />;
            case 'lp':
              return (
                <FaWindowMaximize
                  color="#FFF"
                  size={20}
                  title="Origem: Land Page"
                />
              );
            case 'st':
              return <FaWeebly color="#FFF" size={20} title="Origem: Site" />;
            case 'mailing':
              return (
                <IoMdMail color="#FFF" size={20} title="Origem: Mailing" />
              );
            case 'ch':
              return (
                <FaRocketchat color="#FFF" size={20} title="Origem: Chat" />
              );
            default:
              return (
                <FaTimes color="#FFF" size={20} title="Origem: Sem canal" />
              );
          }
        },
      },
    },
    {
      name: 'lead.email',
      label: 'E-mail',
      options: {
        sort: false,
        filter: true,
        filterType: 'custom',
        customFilterListOptions: { render: v => `E-mail:${v}` },
        filterList: [],
        filterOptions: {
          names: [],
          display: (filterList, onChange, index, column) => (
            <div>
              <FormLabel>E-mail</FormLabel>
              <FormGroup row>
                <DebounceTextField
                  filter={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  type="text"
                />
              </FormGroup>
            </div>
          ),
        },
      },
    },
    {
      name: 'lead.telefone',
      label: 'Telefone',
      options: {
        sort: false,
        filter: true,
        filterType: 'custom',
        customFilterListOptions: { render: v => `Telefone:${v}` },
        filterList: [],
        filterOptions: {
          names: [],
          display: (filterList, onChange, index, column) => (
            <div>
              <FormLabel>Telefone</FormLabel>
              <FormGroup row>
                <DebounceTextField
                  filter={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  type="number"
                />
              </FormGroup>
            </div>
          ),
        },
      },
    },
    {
      name: 'lead.produto.name',
      label: 'Produto',
      options: {
        sort: false,
        filter: true,
        filterType: 'dropdown',
        customFilterListOptions: { render: v => `${v}` },
        filterOptions: {
          names: produtos,
        },
      },
    },
    {
      name: 'lead.produto.time.name',
      label: 'Time',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'ten',
      label: 'Tentativa',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'lead.user.name',
      label: 'Usuário',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'createdAt',
      label: 'Data de entrada',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'dataFormat',
      label: 'Proximo Atendimento',
      options: {
        filter: false,
        sort: false,
      },
    },

    {
      name: 'statusFormat',
      label: 'Status',
      options: {
        sort: false,
        filter: true,
        filterType: 'dropdown',
        customFilterListOptions: { render: v => `${v}` },
        filterOptions: {
          names: [
            'Status:Iniciado',
            'Status:Em atendimento',
            'Status:Cancelado',
            'Status:Finalizado',
            'Status:Enviado',
          ],
        },
      },
    },
  ];

  if (loading) {
    return <Load />;
  }

  return (
    <Container>
      <h4>Atendimento</h4>
      <Card size={100}>
        <Menus>
          <Filtro>
            <DS
              selected={dateInit}
              onChange={date => setDateInit(date)}
              locale="pt-BR"
              placeholderText="Data inicial"
              dateFormat="dd/MM/yyyy"
              showPopperArrow={false}
              withPortal
            />
            <DS
              selected={dateFinish}
              onChange={date => setDateFinish(date)}
              locale="pt-BR"
              minDate={dateInit}
              placeholderText="Data final"
              dateFormat="dd/MM/yyyy"
              showPopperArrow={false}
              withPortal
            />
            <Button type="button" onClick={handleFiltrar}>
              Filtrar
            </Button>
          </Filtro>
        </Menus>
        {!loading && (
          <Table
            data={dados}
            page={page}
            perPage={perPage}
            columns={columns}
            total={total}
            pagination={number => handlePagination(number)}
            editPerPege={number => handlePerPage(number)}
            search={value => handleSearch(value)}
            loading={carregar}
            handleExportCSV={handleExportCSV}
            handleFilterSubmit={resultados => handleFilterSubmit(resultados)}
            editar={number => handleAtendimento(number)}
            reset={handleReset}
          />
        )}
      </Card>
    </Container>
  );
}
